<template>

  <div class="select-themes-view" v-if="loaded">
    <div>
      <div class="tabs" ref="tabsContainer">
        <ul>
          <li v-for="tab of tabs" :class="isActiveTab(tab.id) ? 'is-active' :''" v-on:click="setIsActive(tab.id)">
            <div>{{ tab.title }}</div>
          </li>
        </ul>
      </div>
      <template v-for="tab of tabs">
        <div class="tabs-content" v-if="!tab.deactivated && isActiveTab(tab.id)"
             v-bind:class="{'deactivated': !isActiveTab(tab.id),'with-sub-tabs':tab.subTabs}">
          <template v-if="tab.subTabs">
            <div class="tabs">
              <ul>
                <template v-for="subTab of tab.subTabs">
                  <li :class="isActiveTab(subTab.id) ? 'is-active' :''"
                      v-on:click="setIsActive(subTab.id)">
                    <div>{{ subTab.title }}</div>
                  </li>
                </template>

              </ul>
            </div>

            <template v-for="subTab of getSubTabsForTab(tab)">
              <div class="tabs-content" v-bind:class="{'deactivated': !isActiveTab(tab.id)}"
                   v-if="!subTab.deactivated && isActiveTab(subTab.id)">

                <template v-for="category of getThemesForTab(subTab)">
                  <div class="tabs-content-sub-header">
                    <template v-if="tab.selectEntriesAs === 'offer'">
                      <div v-if="category['question.offer']">{{ category['question.offer'] }}</div>
                    </template>
                    <template v-if="tab.selectEntriesAs === 'search'">
                      <div v-if="category['question.search']">{{ category['question.search'] }}</div>
                    </template>
                    <template v-if="tab.selectEntriesAs === 'normal'">
                      <div v-if="category['question']">{{ category['question'] }}</div>
                    </template>
                    <div v-if="!category.question && !category['question.search'] && !category['question.offer']">
                      {{ tab.title }}
                    </div>
                  </div>

                  <div class="category-container" v-bind:id="category.id">

                    <template v-if="category.showChildrenSeparately">
                      <select-themes-categories v-bind:singleton="category.singleton" v-bind:parent="child"
                                                v-bind:disable-select-all-checkbox="category.disableSelectAllCheckbox"
                                                v-for="child of category.children" v-bind:key="child.key"
                                                v-bind:category="child" v-bind:step="0" v-on:update="onUpdate"
                                                v-bind:select-as="tab.selectEntriesAs"></select-themes-categories>
                    </template>

                    <select-themes-categories v-bind:singleton="category.singleton" v-bind:parent="category"
                                              v-bind:key="category.key"
                                              v-bind:disable-select-all-checkbox="category.disableSelectAllCheckbox"
                                              v-if="!category.showChildrenSeparately" v-on:update="onUpdate"
                                              v-bind:category="category" v-bind:step="0"
                                              v-bind:select-as="tab.selectEntriesAs"
                    ></select-themes-categories>
                  </div>
                </template>

                <span class="mandatory-warning" v-if="hasTabRequiredCategories(subTab.id)">*{{
                    $t('required-fields')
                  }}</span>
                <custom-button class="primary-button" :icon="'fal fa-chevron-right fa-2x'"
                               :on-clicked="(subTab.isLastTab || isUpdate) ? onSubmit : showNextTab">
                  {{ (subTab.isLastTab || isUpdate) ? $t('save') : $t('next') }}
                </custom-button>

              </div>
            </template>

          </template>
          <template v-else>
            <template v-for="category of getThemesForTab(tab)">
              <div class="tabs-content-sub-header">
                <template v-if="tab.selectEntriesAs === 'offer'">
                  <div v-if="category['question.offer']">{{ category['question.offer'] }}</div>
                </template>
                <template v-if="tab.selectEntriesAs === 'search'">
                  <div v-if="category['question.search']">{{ category['question.search'] }}</div>
                </template>
                <template v-if="tab.selectEntriesAs === 'normal'">
                  <div v-if="category['question']">{{ category['question'] }}</div>
                </template>
                <div v-if="!category.question && !category['question.search'] && !category['question.offer']">
                  {{ tab.title }}
                </div>
              </div>

              <div class="category-container" v-bind:id="category.id">

                <template v-if="category.showChildrenSeparately">
                  <select-themes-categories v-bind:singleton="category.singleton" v-bind:parent="child"
                                            v-bind:disable-select-all-checkbox="category.disableSelectAllCheckbox"
                                            v-for="child of category.children" v-bind:key="child.key"
                                            v-bind:category="child" v-bind:step="0" v-on:update="onUpdate"
                                            v-bind:select-as="tab.selectEntriesAs"></select-themes-categories>
                </template>

                <select-themes-categories v-bind:singleton="category.singleton" v-bind:parent="category"
                                          v-bind:key="category.key"
                                          v-bind:disable-select-all-checkbox="category.disableSelectAllCheckbox"
                                          v-if="!category.showChildrenSeparately" v-on:update="onUpdate"
                                          v-bind:category="category" v-bind:step="0"
                                          v-bind:select-as="tab.selectEntriesAs"
                ></select-themes-categories>
              </div>
            </template>

            <template v-if="$matchMakingExhibitorRole && tab.id === 'PREFERRED-BOOTH-TAB' && hallsWithoutOther">
              <div class="tabs-content-sub-header">
                <div v-html="$t('mm_exhibitor_meeting_point_info')"></div>
              </div>
              <MBFSelect
                  class="themes-hall-select"
                  v-model:selected-value="selectedHall"
                  v-bind:options="hallsWithoutOther"
                  v-on:update:selectedValue="onHallSelected($event)"
                  v-bind:no-selection-allowed="false"
                  v-bind:place-holder="$t('place')"
                  v-bind:translate-function="translateHallName"></MBFSelect>

              <MBFSelect
                  class="themes-stand-select"
                  v-model:selected-value="internalPreferredBooth"
                  v-bind:option-selector="'id'"
                  v-bind:options="selectedHall.stands"
                  v-bind:no-selection-allowed="false"
                  v-bind:place-holder="$t('stand')"
                  v-bind:translate-function="translateStandName"></MBFSelect>
            </template>

            <span class="mandatory-warning" v-if="hasTabRequiredCategories(tab.id)">*{{ $t('required-fields') }}</span>
            <custom-button class="primary-button" :icon="'fal fa-chevron-right fa-2x'"
                           :on-clicked="(tab.isLastTab || isUpdate) ? onSubmit : showNextTab">
              {{ (tab.isLastTab || isUpdate) ? $t('save') : $t('next') }}
            </custom-button>
          </template>
        </div>
      </template>
    </div>

    <div class="floatingErrorMessage" ref="floatingErrorMessage" v-if="floatingErrorMessage">
      <i class="fas fa-exclamation-triangle fa-2x"></i>
      <div>{{ floatingErrorMessage }}</div>
    </div>

  </div>
</template>

<script>

import themes from "../themes-helper";
import SelectThemesCategories from "./select-themes-categories";
import {uuid} from "vue-uuid";
import {isDefined, scrollToTop} from "../../utils";
import CustomButton from "../../components/inputs/CustomButton";
import i18n from "../../i18n";
import MBFSelect from "@/components/inputs/MBFSelect.vue";
import {themesStorage} from "@/main";
import CustomInputText from "@/components/inputs/CustomInputText.vue";
import {appointmentsMixin} from "@/mixins/appointments-mixin";

const {t} = i18n.global;

export default {
  name: "select-themes",
  mixins: [appointmentsMixin],
  components: {CustomInputText, MBFSelect, SelectThemesCategories, CustomButton},
  props: {
    userThemes: {
      default: undefined,
      required: true
    },
    showStartTab: {
      default: false,
      required: false
    },
    startTabId: {
      required: false
    },
    isUpdate: {
      default: false,
      required: false
    },
    userRole: {
      default: undefined,
      required: true
    },
    isDuringRegistration: {
      default: false,
      required: false
    },
    preferred_booth: {
      default: undefined,
      required: false
    }
  },
  watch: {
    startTabId: {
      immediate: true,
      handler(newVal, oldVal) {
        if (isDefined(newVal)) {
          this.activeTabId = newVal;
        }
      }
    },
    preferred_booth:{
      immediate: true,
      handler(newVal, oldVal) {
        if (isDefined(newVal)) {
          this.internalPreferredBooth = newVal;
        }
      }
    }
  },
  data() {
    return {
      activeTabId: themes.getStartTabId(this.userRole),
      availableThemes: undefined,
      tabs: [],
      selectedHall: undefined,
      loaded: false,
      floatingErrorMessage: undefined,
      internalPreferredBooth: undefined
    }
  },
  created() {
    this.availableThemes = themes.getThemesForThemeSelectByLanguage(this.$getCurrentLanguage(), this.isDuringRegistration);
    this.loadInitialHall();
    this.addKeysForUpdateToAllThemes();
    this.createTabs(true);
  },
  mounted() {
    const self = this;
    this.$nextTick(function () {
      if (self.userThemes) {
        self.applyUserThemes();
        self.onFinishedLoading();
      }
    });
  },
  unmounted() {
    if (this.isDuringRegistration) {
      themes.reloadThemesTab(false, this.userRole);
    }
  },
  methods: {
    loadInitialHall() {
      for (const hall of this.hallsWithoutOther) {
        if (hall.stands) {
          if (hall.stands.find(s => s.id === this.internalPreferredBooth)) {
            this.selectedHall = hall;
            return
          }
        }
      }
      if(!isDefined(this.selectedHall)){
        this.selectedHall = this.hallsWithoutOther[0];
      }
    },
    onHallSelected(hall) {
      if (hall.stands && hall.stands.length > 0) {
        this.selectedHall = hall
        this.internalPreferredBooth = hall.stands[0].id
      }
    },
    createTabs(reloadStorage) {
      const tabs = [];
      if (this.showStartTab) {
        tabs.push({
          id: 'start-tab',
          categoriesInTab: [],
          title: t('start-tab-header'),
          deactivated: true
        });
      }
      if (this.$createProfileEnabled) {
        tabs.push({
          id: 'profile-create-tab',
          categoriesInTab: [],
          deactivated: true,
          title: t('profile-create-tab-header'),
        });
      }
      if(reloadStorage){
        themes.reloadThemesTab(this.isDuringRegistration, this.userRole);
      }
      tabs.push(...themes.getThemeSelectTabs());

      if (this.isDuringRegistration) {
        for (const tab of tabs) {
          if (!tab.deactivated && tab.subTabs) {
            this.activeTabId = this.getSubTabsForTab(tab)[0].id;
            break;
          }
        }
      }

      this.tabs = tabs;
    },
    async onFinishedLoading() {
      this.loaded = true;
      await this.$nextTick();
      scrollToTop();
    },
    addKeysForUpdateToAllThemes() {
      // key is used to update component with Vue :key property
      for (const category of this.availableThemes) {
        if (category.showChildrenSeparately && category.children) {
          for (const child of category.children) {
            child['key'] = uuid.v4();
          }
          continue;
        }
        category['key'] = uuid.v4();
      }
    },
    onUpdate(categoryId) {
      this.checkForAllSelectedCategoriesAndEnableCheckboxes();
      const isTabValid = this.validateCategoriesInTab(this.activeTabId, categoryId);
      if (isTabValid !== true) {
        this.floatingErrorMessage = isTabValid.message;
      } else {
        this.floatingErrorMessage = undefined;
      }
      let categoryToUpdate = this.availableThemes.find(c => c.id === categoryId); // search flat in themes first for performance
      if (categoryToUpdate !== undefined) {
        categoryToUpdate['key'] = uuid.v4();
      } else {
        categoryToUpdate = this.findCategory(categoryId);
        if (categoryToUpdate !== undefined) {
          categoryToUpdate['key'] = uuid.v4();
        }
      }
      if(isDefined(process.env.VUE_APP_MATCH_MAKING_EXHIBITOR_ROLE_ROOT) && isDefined(process.env.VUE_APP_MATCH_MAKING_EXHIBITOR_ROLE) &&
       categoryToUpdate.id === process.env.VUE_APP_MATCH_MAKING_EXHIBITOR_ROLE_ROOT){
        const selected = categoryToUpdate.children.find(c => c.selected === true);
        if(isDefined(selected) && selected.id === process.env.VUE_APP_MATCH_MAKING_EXHIBITOR_ROLE){
          themesStorage.addPreferredBoothTab();
          this.createTabs(false)
        }else {
          this.internalPreferredBooth = undefined;
          themesStorage.removePreferredBoothTab();
          this.createTabs(false)
        }
      }
    },
    findRootForCategory(categoryId) {
      for (const c of this.availableThemes) {
        if (c.id === categoryId) {
          return c;
        }
        let category = this.findRootForCategoryTraverse(c.children, categoryId);
        if (category !== undefined) {
          return c;
        }
      }
      return undefined;
    },
    findRootForCategoryTraverse(children, categoryId) {
      for (const child of children) {
        if (child.children) {
          if (child.id === categoryId) {
            return child;
          } else {
            this.findCategoryTraverse(child.children, categoryId);
          }
        }
      }
      return undefined;
    },
    findCategory(categoryId) {
      for (const c of this.availableThemes) {
        if (c.id === categoryId) {
          return c;
        }
        let category = this.findCategoryTraverse(c.children, categoryId);
        if (category !== undefined) {
          return category;
        }
      }
      return undefined;
    },
    findCategoryTraverse(children, categoryId) {
      for (const child of children) {
        if (child.children) {
          if (child.id === categoryId) {
            return child;
          } else {
            this.findCategoryTraverse(child.children, categoryId);
          }
        }
      }
      return undefined;
    },
    showCategoriesNotValidErrorMessage(isTabValid) {
      this.$toasted.error(isTabValid.message, {
        timeout: 2000,
        position: "top-center"
      });
    },
    showNextTab() {


      for (const [i, tab] of this.tabs.entries()) {
        const isSubTab = (isDefined(tab.subTabs) && isDefined(tab.subTabs.find(t => t.id === this.activeTabId)));
        if (tab.id === this.activeTabId || isSubTab) {
          const isTabValid = this.validateCategoriesInTab(this.activeTabId);
          if (isTabValid === true) {

            if (isSubTab) {
              //Check if active Tab is last Subtab
              let subTabs = this.getSubTabsForTab(tab);
              const currentTabPos = subTabs.findIndex(t => t.id === this.activeTabId);
              if (currentTabPos === subTabs.length - 1) {
                const nextTab = this.tabs[i + 1];
                if (isDefined(nextTab.subTabs)) {
                  this.activeTabId = this.getSubTabsForTab(nextTab)[0].id;
                } else {
                  this.activeTabId = nextTab.id;
                }
              } else {
                const nextTab = subTabs[currentTabPos + 1];
                this.activeTabId = nextTab.id;
              }
            } else {
              const nextTab = this.tabs[i + 1];
              if (isDefined(nextTab.subTabs)) {
                this.activeTabId = this.getSubTabsForTab(nextTab)[0].id;
              } else {
                this.activeTabId = nextTab.id;
              }
            }
            scrollToTop();
          } else {
            this.scrollToCategory(isTabValid.categoryId);
            this.showCategoriesNotValidErrorMessage(isTabValid);
          }
          break;
        }
      }
    },
    // validates selected Categories in Tab. Returns Category id if Category is not Valid, else returns true
    // when optionalCategoryId is set only this category is validated for this tab
    validateCategoriesInTab(tabId, optionalCategoryId) {

      const tab = this.getTabById(tabId);
      const categoriesForTab = this.getThemesForTab(tab);
      const selectedThemes = this.getSelectedThemes(true);

      let categoriesInTab = tab.categoriesInTab;
      if (isDefined(optionalCategoryId)) {
        const rootCategory = this.findRootForCategory(optionalCategoryId);
        if (rootCategory !== undefined) {
          optionalCategoryId = rootCategory.id;
        }
        categoriesInTab = categoriesInTab.filter(c => c === optionalCategoryId);
      }


      for (const category of categoriesInTab) {
        const c = categoriesForTab.find(c => c.id === category);

        if (c.maxSelectCount) {
          if (c.hasSearchAndOffer) {
            if (selectedThemes[category] && selectedThemes[category][tab.selectEntriesAs]) {
              if (selectedThemes[category][tab.selectEntriesAs].length > c.maxSelectCount) {
                return {
                  categoryId: c.id,
                  message: this.$tc('selection-error-too-many', c.maxSelectCount, {
                    max: c.maxSelectCount,
                    title: c.title
                  })
                };
              }
            }
          } else {
            if (selectedThemes[category]) {
              if (selectedThemes[category].length > c.maxSelectCount) {
                return {
                  categoryId: c.id,
                  message: this.$tc('selection-error-too-many', c.maxSelectCount, {
                    max: c.maxSelectCount,
                    title: c.title
                  })
                };
              }
            }
          }
        }

        if (c.required) {
          if (c && !c.hasSearchAndOffer) {
            if (!selectedThemes[category] || selectedThemes[category].length === 0) {
              return {categoryId: c.id, message: this.$t('selection-error-mandatory', {title: c.title})};
            }
          } else if (c && c.hasSearchAndOffer) {
            if (!selectedThemes[category] || !selectedThemes[category][tab.selectEntriesAs] || selectedThemes[category][tab.selectEntriesAs].length === 0) {
              return {categoryId: c.id, message: this.$t('selection-error-mandatory', {title: c.title})};
            }
          }
        }
        if (c.singleton) {
          if (c && !c.hasSearchAndOffer) {
            if (selectedThemes[category] && selectedThemes[category].length > 1) {
              return {categoryId: c.id, message: this.$tc('selection-error-too-many', 1, {max: 1, title: c.title})};
            }
          } else if (c && c.hasSearchAndOffer) {
            if (isDefined(selectedThemes[category]) && isDefined(selectedThemes[category][tab.selectEntriesAs]) && selectedThemes[category][tab.selectEntriesAs].length > 1) {
              return {categoryId: c.id, message: this.$tc('selection-error-too-many', 1, {max: 1, title: c.title})};
            }
          }
        }
      }
      return true;
    },
    validateCurrentActiveTab() {
      return this.validateCategoriesInTab(this.activeTabId);
    },
    // validates Categories of all Tabs. Returns Tab Id and Category id if an Category is not Valid, else return true
    validateAllTabs() {
      for (const tab of this.tabs) {
        const isCategoryValid = this.validateCategoriesInTab(tab.id);
        if (isCategoryValid !== true) {
          return {tabId: tab.id, categoryId: isCategoryValid.categoryId, message: isCategoryValid.message};
        }
      }
      return true;
    },
    getTabById(tabId) {
      for (const t of this.tabs) {
        if (isDefined(t.subTabs)) {
          for (const subTab of t.subTabs) {
            if (subTab.id === tabId) {
              return subTab;
            }
          }
        }
        if (t.id === tabId) {
          return t;
        }
      }
      return undefined;
    },
    isActiveTab(tabId) {
      if (this.activeTabId === tabId) {
        return true;
      }
      //check for subTab

      for (const t of this.tabs) {
        if (isDefined(t.subTabs) && t.id === tabId) {
          for (const subTab of t.subTabs) {
            if (this.activeTabId === subTab.id) {
              return true;
            }
          }
        }
      }
      return false;
    },
    setIsActive(tabId) {
      let tab = this.getTabById(tabId);

      if (!isDefined(tab) || tab.deactivated) {
        return;
      }
      const isTabValid = this.validateCategoriesInTab(this.activeTabId)
      if (isTabValid === true) {
        if (isDefined(tab.subTabs)) {
          let subTabs = this.getSubTabsForTab(tab);
          this.activeTabId = subTabs[0].id;
        } else {
          this.activeTabId = tabId;
        }
      } else {
        this.showCategoriesNotValidErrorMessage(isTabValid);
      }
    },
    hasTabRequiredCategories(tabId) {
      const tab = this.getTabById(tabId);
      for (const category of tab.categoriesInTab) {
        const c = this.availableThemes.find(c => c.id === category);
        if (c.required) {
          return true;
        }
      }
      return false;
    },
    checkForAllSelectedCategoriesAndEnableCheckboxes() {
      for (const category of this.availableThemes) {
        if (category.hasSearchAndOffer) {
          category.allSelectedSearch = this.checkForAllSelectedCategoriesAndEnableCheckboxesTraverse(category.children, 'search')
          category.allSelectedOffer = this.checkForAllSelectedCategoriesAndEnableCheckboxesTraverse(category.children, 'offer');
        } else {
          category.allSelected = this.checkForAllSelectedCategoriesAndEnableCheckboxesTraverse(category.children, 'normal');
        }
      }
    },
    checkForAllSelectedCategoriesAndEnableCheckboxesTraverse(children, selectAs) {
      let allSelected = true;
      for (const child of children) {
        if (child.children) {
          if (selectAs === 'offer') {
            child.allSelectedOffer = this.checkForAllSelectedCategoriesAndEnableCheckboxesTraverse(child.children, 'offer');
            if (!child.allSelectedOffer) {
              allSelected = false;
            }
          } else if (selectAs === 'search') {
            child.allSelectedSearch = this.checkForAllSelectedCategoriesAndEnableCheckboxesTraverse(child.children, 'search');
            if (!child.allSelectedSearch) {
              allSelected = false;
            }
          } else if (selectAs === 'normal') {
            child.allSelected = this.checkForAllSelectedCategoriesAndEnableCheckboxesTraverse(child.children, 'normal');
            if (!child.allSelected) {
              allSelected = false;
            }
          }
        } else {
          if (selectAs === 'offer') {
            if (!child.selected_offer) {
              allSelected = false;
            }
          } else if (selectAs === 'search') {
            if (!child.selected_search) {
              allSelected = false;
            }
          } else if (selectAs === 'normal') {
            if (!child.selected) {
              allSelected = false;
            }
          }
        }
      }
      return allSelected;
    },
    applyUserThemes() {
      for (const [key, value] of Object.entries(this.userThemes)) {
        if (!Array.isArray(value)) {
          if (value.search) {
            for (const entryId of value.search) {
              this.selectEntry(key, entryId, 'search');
            }
          }
          if (value.offer) {
            for (const entryId of value.offer) {
              this.selectEntry(key, entryId, 'offer');
            }
          }
        } else {
          for (const entryId of value) {
            this.selectEntry(key, entryId)
          }
        }
      }
      this.checkForAllSelectedCategoriesAndEnableCheckboxes()
    },
    selectEntry(categoryId, entryId, selectedAs) {
      const category = this.availableThemes.find(category => category.id === categoryId);

      if (category && category.children) {
        this.selectEntryTraverse(category.children, entryId, selectedAs)
      }

      this.$forceUpdate();
    },
    selectEntryTraverse(children, entryId, selectedAs) {
      for (const child of children) {
        if (child.children) {
          this.selectEntryTraverse(child.children, entryId, selectedAs);
        } else {
          if (child.id === entryId) {
            switch (selectedAs) {
              case 'offer':
                child['selected_offer'] = true;
                break;
              case 'search':
                child['selected_search'] = true;
                break;
              default:
                child['selected'] = true;
                break;
            }
          }
        }
      }
    },
    getSubTabsForTab(tab) {
      return tab.subTabs;
    },
    getThemesForTab(tab) {
      return this.availableThemes.filter(category => isDefined(tab) && tab.categoriesInTab.includes(category.id));
    },
    getQuestion(tab, category) {
      return this.$t(tab.id + '-sub-header');
    },
    getSelectedThemes(withoutParentIds) {
      const selectedThemes = {};
      for (const category of this.availableThemes) {
        this.getSelectedThemesInCategoryTraverse(category.children, selectedThemes, category, withoutParentIds);
      }
      if (!withoutParentIds && this.userThemes) {
        for (const key in this.userThemes) {
          if (!isDefined(selectedThemes[key])) {
            let categoryIsAvailable = this.availableThemes.find(c => c.id === key);
            if (!categoryIsAvailable) {
              selectedThemes[key] = this.userThemes[key];
            }
          }
        }
      }
      return selectedThemes;
    },
    getSelectedThemesInCategoryTraverse(children, selectedThemes, category, withoutParentIds) {
      for (const child of children) {
        if (child.children) {
          if (!withoutParentIds) {
            if (category.hasSearchAndOffer) {
              if (child.allSelectedSearch || child.allSelectedOffer) {
                if (!selectedThemes[category.id]) {
                  selectedThemes[category.id] = {};
                }
                if (child.allSelectedOffer) {
                  if (!selectedThemes[category.id].offer) {
                    selectedThemes[category.id].offer = [];
                  }
                  selectedThemes[category.id].offer.push(child.id);
                }
                if (child.allSelectedSearch) {
                  if (!selectedThemes[category.id].search) {
                    selectedThemes[category.id].search = [];
                  }
                  selectedThemes[category.id].search.push(child.id);
                }
              }
            } else {
              if (child.allSelected) {
                if (!selectedThemes[category.id]) {
                  selectedThemes[category.id] = [];
                }
                selectedThemes[category.id].push(child.id);
              }
            }
          }
          this.getSelectedThemesInCategoryTraverse(child.children, selectedThemes, category, withoutParentIds);
        } else {
          if (category.hasSearchAndOffer) {
            if (child.selected_offer || child.selected_search) {
              if (!selectedThemes[category.id]) {
                selectedThemes[category.id] = {};
              }
              if (child.selected_offer) {
                if (!selectedThemes[category.id].offer) {
                  selectedThemes[category.id].offer = [];
                }
                selectedThemes[category.id].offer.push(child.id);
              }
              if (child.selected_search) {
                if (!selectedThemes[category.id].search) {
                  selectedThemes[category.id].search = [];
                }
                selectedThemes[category.id].search.push(child.id);
              }
            }
          } else {
            if (child.selected) {
              if (!selectedThemes[category.id]) {
                selectedThemes[category.id] = [];
              }
              selectedThemes[category.id].push(child.id);
            }
          }
        }
      }
    },
    onSubmit() {
      const areTabsValid = this.isUpdate ? this.validateCategoriesInTab(this.activeTabId) : this.validateAllTabs();
      if (areTabsValid === true) {
        const selectedThemes = this.getSelectedThemes();
        this.$emit('submit', {selectedThemes: selectedThemes, preferred_booth: this.internalPreferredBooth});
      } else {
        this.scrollToCategory(areTabsValid.categoryId);
        this.showCategoriesNotValidErrorMessage(areTabsValid);
      }
    },
    scrollToCategory(id) {
      const e = document.getElementById(id);
      if (isDefined(e)) {
        e.scrollIntoView();
      }
    }
  }
}
</script>
